// src/shared/register.js — общият вид на списъците („регистрите").
//
// Макс, 29.10.2026: „всички менюта, които са тип таблици, да изглеждат като
// Доставки". Затова екранът „Доставки" е образецът, а тук са парчетата му,
// за да не се пише всеки списък наново:
//   regHead     — заглавието вляво и ВСИЧКИ бутони вдясно на един ред
//                 (последният е основният, тъмен: „+ Нова фактура"); на тесен
//                 екран бутоните се пренасят на нов ред (.reg-actions);
//   regFilters  — лентата с филтрите, всеки с надпис ОТГОРЕ (regField), а
//                 бутоните за бърз избор — на отделен ред под тях (regTools);
//   regCount    — „18 от 18" над таблицата, вляво;
//   REG_TABLE   — по-ниски редове (един ред текст, дългото с „…").
// Лентата носи и класа .filter-bar: по него src/shared/stickyList.js я
// залепва горе при плъзгане (ПРОМТ-37) — не го махай.
// Стиловете са в public/styles.css при .pur-* (доставките) — двата набора
// класове са в едни и същи правила, за да не се разминат.

import { el, field } from './dom.js';

export const REG_TABLE = 'list reg-list';

// buttons — второстепенните (светли), primary — основният; празните се пропускат.
// extra — неща между заглавието и бутоните (напр. лентата за избрани редове).
export function regHead(title, buttons, primary, extra) {
  const list = (buttons || []).filter(Boolean);
  return el('div', { class: 'panel-head reg-head' },
    el('h2', { text: title }),
    ...(extra || []),
    el('div', { class: 'reg-actions' }, ...list, primary || null));
}

export function regField(label, control, size) {
  return field(label, control, { size: size || 'm' });
}

export function regTools(...btns) {
  const list = btns.filter(Boolean);
  return list.length ? el('div', { class: 'reg-tools' }, ...list) : null;
}

export function regFilters(...nodes) {
  return el('div', { class: 'filter-bar reg-filters' }, ...nodes.filter(Boolean));
}

// Броячът над таблицата. set(показани, общо, търсено) — при празен резултат
// казва и какво е търсено, както в доставките.
export function regCount() {
  const node = el('div', { class: 'reg-shown', role: 'status' });
  node.set = (shown, total, q) => {
    node.textContent = shown + ' от ' + total + (shown || !q ? '' : ' — нищо не е намерено за „' + q + '".');
  };
  return node;
}

// Клетка с един ред текст: дългото се реже с „…", целият текст е при задържане.
export function cutCell(text, attrs) {
  const t = text == null || text === '' ? '—' : String(text);
  return el('td', Object.assign({ class: 'reg-cut', title: t === '—' ? '' : t, text: t }, attrs || {}));
}
